<template>
    <div class="roothome_m">

        <div class="wrapper">
            <!-- Sidebar Holder -->
            <nav id="sidebar">
                <div id="dismiss">
                    <img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu1">
                </div>

                <div class="sidebar-header" style="font-size: 1.1em">
                    <br>
                    <br>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'mHome'}">
                        <img src="/static/imgs/advice_b_horizontal.png" alt="menu" style="width: 60%">
                    </router-link>
                    <br>
                    <br>
                    <span v-if="user.idioma==0" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; font-weight: bold;">Português</span>
                    <span v-if="user.idioma!=0" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; " @click="changeIdioma(0)">Português</span>
                    <span v-if="user.idioma==1" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; font-weight: bold;">English</span>
                    <span v-if="user.idioma!=1" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; " @click="changeIdioma(1)">English</span>
                    <span v-if="user.idioma==2" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; font-weight: bold;">Español</span>
                    <span v-if="user.idioma!=2" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt;" @click="changeIdioma(2)">Español</span>
                    <br>
                    <br>

                    <div style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <div class="div_botao_t_b" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                        </div>

                        <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'mRegisterUser'}"
                            style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                            <div class="div_botao_t_w">
                                <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                            </div>
                        </router-link>
                    </div>
                </div>

                <ul class="list-unstyled components">
                    <li class="active">
                        <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu">{{ getInterText(inter_ind.categorias) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu" >
                            <li v-for="item in cats_full">
                                <router-link :to="{ query: { idCat: item.id }, params: { stabs: estabs_full, categs: cats_full, anuncios: anuncios}, name: 'mHome'}">
                                    <a href="#"><img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">{{ item.nome }}</a>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="#">{{ getInterText(inter_ind.quem_somos) }}</a>
                    </li>
                    <li @click="atualizaEstabs(-2, true)">
                        <a href="#">O{{ getInterText(inter_ind.os) }} 10+</a>
                    </li>
                    <li>
                        <a href="#">{{ getInterText(inter_ind.contato) }}</a>
                    </li>
                    <li class="active">
                        <a href="#pageSubmenu2" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu2">
                            <li v-for="item in telefoneUteis">
                                <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>

            </nav>

            <div>

                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0" style="box-shadow: 0px 3px 10px var(--font-dark-gray);">
                    <div align="center" class="head0_2m">
                        <div class="head1m">
                            <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToBack" @mouseover="setPointerCursor">
                            <!--<a href="#" onclick="history.go(-1)"><img src="/static/imgs/ic_back.png" class="im_menu3"></a>-->
                        </div><div class="head2m">

                        <!--<router-link :to="{ params: { stabs: estabs_full, categs: cats_full}, name: 'mHome'}">-->
                            <span class="tx_logol" >{{ getInterText(inter_ind.minha_conta) }}</span>
                            <!--<img src="/static/imgs/advicep_horizontal2_small.png" alt="Logo Advice" class="im_logol">-->
                        <!--</router-link>-->
                    </div><div  class="head3m">
                        <router-link v-if="!user.sucess" :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'mRegisterUser'}">
                            <div class="di_profile">
                                <img src="/static/imgs/ic_perfil.png" alt="profile" class="im_profile">
                            </div>
                        </router-link>
                        <div v-else class="di_profile" @click="showPopEscritorio()">
                            <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                                <span class="tx_initials" >{{ getInitials(user) }}</span>
                            </div>
                            <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_2">
                            <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_2">
                        </div>
                        <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                            <div class="arrow_top"></div>
                            <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="showPopEscritorio()">{{ getInterText(inter_ind.minha_conta) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                        </div>
                    </div>

                    </div>
                </div>

                <!--<div id="trans_area" class="translate_control" style="font-weight: bold; background-color: purple; display: none;">-->
                <!--</div>-->

                <!-- ################    Estabelecimentos TAB Header ################# -->
                <div style="display: flex; flex-direction: row; margin-top: var(--top-bar-heigth); flex-wrap: wrap;">
                    <div v-if="currentTab==3" class="di_tab_s" @click="changeTab(3)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_mensagens_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> {{ getInterText(inter_ind.mensagens) }} ({{ commentaries.length }})</span>
                    </div>
                    <div v-else class="di_tab" @click="changeTab(3)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_mensagens_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> {{ getInterText(inter_ind.mensagens) }} ({{ commentaries.length }})</span>
                    </div>

                    <div class="di_tab" style="margin: 0; margin-bottom: 2vh !important; margin-top: 2vh !important; background-color: var(--menu-icon-gray); height: auto; max-width: 1px; padding: 0; border-width: 0; font-size: 0;">
                    </div>

                    <div v-if="currentTab==2" class="di_tab_s" @click="changeTab(2)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> {{ getInterText(inter_ind.favoritos) }} ({{ getEstabsUser(2).length }}) </span>
                    </div>
                    <div v-else class="di_tab" @click="changeTab(2)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> {{ getInterText(inter_ind.favoritos) }} ({{ getEstabsUser(2).length }})</span>
                    </div>

                    <div class="di_tab" style="margin: 0; margin-bottom: 2vh !important; margin-top: 2vh !important; background-color: var(--menu-icon-gray); height: auto; max-width: 1px; padding: 0; border-width: 0; font-size: 0;">
                    </div>

                    <div v-if="currentTab==1" class="di_tab_s" @click="changeTab(1)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> {{ getInterText(inter_ind.minhas_paginas) }} ({{ getEstabsUser(1).length }})</span>
                    </div>
                    <div v-else class="di_tab" @click="changeTab(1)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> {{ getInterText(inter_ind.minhas_paginas) }} ({{ getEstabsUser(1).length }})</span>
                    </div>


                    <div v-if="currentTab==4 && user.tipo == 1" class="di_tab_s" @click="changeTab(4)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> Liberação ADM ({{ getEstabsUser(4).length }}) </span>
                    </div>
                    <div v-else-if="user.tipo == 1" class="di_tab" @click="changeTab(4)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> Liberação ADM ({{ getEstabsUser(4).length }}) </span>
                    </div>

                    <div class="di_tab" style="margin: 0; margin-bottom: 2vh !important; margin-top: 2vh !important; background-color: var(--menu-icon-gray); height: auto; max-width: 1px; padding: 0; border-width: 0; font-size: 0;">
                    </div>

                    <div v-if="currentTab==5 && user.tipo == 1" class="di_tab_s" @click="changeTab(5)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> Dica Advice ({{ anuncios.length }}) </span>
                    </div>
                    <div v-else-if="user.tipo == 1" class="di_tab" @click="changeTab(5)" onMouseOver="this.style.cursor='pointer'">
                        <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                        <span class="tx_notselect" style="margin-top: 0.5vw"> Dica Advice ({{ anuncios.length }}) </span>
                    </div>

                </div>

                <!--<div v-if="currentTab==4 && user.tipo == 1" style="margin-left: 3%; display: inline-block; background-color: white;">-->
                    <!--<span @click="changeTab(4)" style="cursor: pointer;">Liberação ADM ({{ getEstabsUser(4).length }})</span>-->
                <!--</div>-->
                <!--<div v-if="currentTab!=4 && user.tipo == 1" style="margin-left: 3%;">-->
                    <!--<span @click="changeTab(4)" style="cursor: pointer;">Liberação ADM ({{ getEstabsUser(4).length }})</span>-->
                <!--</div>-->

                <!-- Texto de apresentação-->
                <div v-if="user.showMsg1 || user.showMsg2 || user.showMsg3" style="display: flex; flex-direction: row; align-items : center; justify-content: center; width: 98%; max-width: 98%; flex-wrap: wrap; margin-left: 1%; margin-right: 1%; margin-top: var(--minhaPagina-margin-top);">
                    <div class="div_apresenta" v-if="user.showMsg3 && currentTab == 3">
                        <img class="im_apresenta" src="/static/imgs/ic_msg_purple.png">
                        <span class="tx_apresenta">Mais facilidade para você poder acompanhar e gerenciar os comentários.</span>
                        <span class="tx_apresenta">Todas as interações de usuários direcionadas ao seu perfil, ou em suas páginas, estarão disponíveis para resposta por aqui.</span>
                        <span class="tx_apresenta_ok" @click="closeUserMsg(3)">ENTENDI</span>
                    </div>

                    <div class="div_apresenta" v-if="user.showMsg2 && currentTab == 2">
                        <img class="im_apresenta" src="/static/imgs/ic_tick_purple.png">
                        <span class="tx_apresenta">Todas as páginas que foram marcadas como favoritas serão exibidas aqui.</span>
                        <span class="tx_apresenta">Uma ótima forma de salvar e organizar em um só local os melhores destinos.</span>
                        <span class="tx_apresenta_ok" @click="closeUserMsg(2)">ENTENDI</span>
                    </div>

                    <div class="div_apresenta" v-if="user.showMsg1 &&  currentTab == 1">
                        <img class="im_apresenta" style="width: 15%;" src="/static/imgs/ic_new_pg_purple.png">
                        <span class="tx_apresenta">Para você que quer divulgar o seu estabelecimento, ou algum tipo de serviço que se enquadre em nossa proposta, crie a sua página, faça bons negócios, e contribuia com o turismo do Estado.</span>
                        <span class="tx_apresenta"> Clique no link abaixo para ficar por dentro dos requisitos básicos de criação de página.</span>
                        <div style="display: flex; justify-content: space-between;">
                            <span class="tx_apresenta_ok" style="margin-left: -3%;" @click="showCriacaoPagina(true)">REQUISITOS PARA A CRIAÇÃO DE PÁGINA</span>
                            <span class="tx_apresenta_ok" @click="closeUserMsg(1)">ENTENDI</span>
                        </div>
                    </div>


                    <div class="div_apresenta" v-if="showCriacaoPg">
                        <img class="im_apresenta" style="width: 15%;" src="/static/imgs/ic_new_pg_purple.png">
                        <span class="tx_apresenta_title" style="cursor: unset; align-self: unset;">Requisitos Advice para criação de página:</span>
                        <span class="tx_apresenta">Preencha todos os campos. <img src="static/imgs/ic_joia_purple.png" style="height: 4vw; object-fit: contain"> </span>
                        <span class="tx_apresenta">No texto de apresentação procure ser claro, apresentando todas as informações necessárias. Foque nos pontos fortes do seu negócio. <img src="static/imgs/ic_joia_purple.png" style="height: 4vw; object-fit: contain"> </span>
                        <span class="tx_apresenta">Fique atento às categorias que a sua página se enquadra. Podendo escolher até 3. <img src="static/imgs/ic_joia_purple.png" style="height: 4vw; object-fit: contain"> </span>
                        <span class="tx_apresenta">Poste fotos que valorizem a sua página. Fotos horizontais, com uma boa iluminação, nitidez e foco. Não se esqueça de variar os ângulos para mostrar todas as perspectivas necessárias. <img src="static/imgs/ic_joia_purple.png" style="height: 4vw; object-fit: contain"> </span>
                        <span class="tx_apresenta_ok" @click="showCriacaoPagina(false)">ENTENDI</span>
                    </div>


                </div>


                <!-- ################    Estabelecimentos Mesmo  ################# -->
                <div style="display: flex; flex-direction: row; margin-top: 20px;">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 100%;">

                        <!-- MINHA PAGINA E FAVORITOS-->
                        <div v-for="item in getEstabsUserOrder(currentTab)" v-if="(currentTab == 1 || currentTab == 2 || currentTab == 4) && item.tbFotos[0]!=null" class="di_mmp_estab0">

                            <div class="di_mmp_estab1" style="display: flex; flex-direction: row; width: 75vw; height: 25vw;" v-if="item.tbFotos[0]!=null">
                                <router-link :to="{ query: { id: item.id }, params: { stabs: estabs_full, categs: cats_full, anuncios: anuncios}, name: 'mEstabelecimento'}" style="margin: 0; padding: 0;">
                                    <div class="di_mmp_estab2" >
                                        <img onerror="tryReloadImages(this)" style="width: 33vw; height: 25vw; border-radius: 5px 0 0 5px; object-fit: cover;" v-if="item.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + item.tbFotos[0].file" alt="Foto Principal" class="imgDestaques"/><br>
                                    </div><br>
                                </router-link>
                                <div style="display: flex; flex-direction: column; width: 100%; margin-left: 2vw; justify-content: space-between; padding-bottom: 1vh; padding-top: 0.5vh;">
                                    <div style="display: flex; flex-direction: column;">
                                        <span class="tx_title_estab" v-html="decodeChars(item.nome)"> </span>

                                        <span style="font-family: 'Humanst521LTBT'; font-size: 3.5vw;" v-html="decodeChars(item.cidade)"> </span>
                                        <span v-if="(currentTab == 4)" style="font-family: 'Humanst521LTBT'; font-size: 3vw;">User: {{ item.idUsuario }}</span>
                                        <span v-if="(currentTab == 4)" style="font-family: 'Humanst521LTBT'; font-size: 3vw;">Cad: {{ item.dtCadastro }}</span>
                                        <span v-if="(currentTab == 4)" style="font-family: 'Humanst521LTBT'; font-size: 3vw;">Alt: {{ item.dtAlteracao }}</span>
                                    </div>

                                    <div class="di_star_wrap" style="max-width: 16vw; height: 3vw;" >
                                        <div alt="estrelas" class="im_star" :style="'width: ' + ((item.avaliacao * 100)/5.0) + '%;'" align="right"/>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; width: 20vw; justify-content: center;">
                                <div v-if="currentTab == 1 || currentTab == 4" style="display: flex; flex-direction: column; justify-content: space-evenly; align-items: center;">
                                    <!--<span class="bt_circle" style="margin-bottom: 2vw"> Avaliações </span>-->
                                    <!--<span class="bt_circle2"> Patrocinar </span>-->
                                    <router-link :to="{ params: { stab: item, stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'mRegisterEstab'}">
                                        <div style="display: flex; flex-direction: row;" onMouseOver="this.style.cursor='pointer'">
                                            <img style="width: 4vw; height: 4vw; margin-right: 6px;" src='/static/imgs/ic_edit_sq.png' alt="Foto Principal" class="imgDestaques"/><br>
                                            <span style="align-self: center;">{{ getInterText(inter_ind.editar) }}</span>
                                        </div>
                                    </router-link>


                                    <div style="display: flex; flex-direction: row; align-items: center;" @click="sendAprovado(item)">
                                        <img v-if="!item.aprovado"               style="width: 2vw; height: 2vw; margin-right: 6px;" src='/static/imgs/ic_ball_red.png' alt="Foto Principal" class="imgDestaques"/>
                                        <img v-if="item.aprovado && item.ativo"  style="width: 2vw; height: 2vw; margin-right: 6px;" src='/static/imgs/ic_ball_green.png' alt="Foto Principal" class="imgDestaques"/>
                                        <img v-if="item.aprovado && !item.ativo" style="width: 2vw; height: 2vw; margin-right: 6px;" src='/static/imgs/ic_ball_gray.png' alt="Foto Principal" class="imgDestaques"/>
                                        <span v-if="!item.aprovado"               style="align-self: center; font-size: 2vw;">{{ getInterText(inter_ind.em_analise) }}</span>
                                        <span v-if="item.aprovado && item.ativo"  style="align-self: center; font-size: 2vw;">{{ getInterText(inter_ind.ativa) }}</span>
                                        <span v-if="item.aprovado && !item.ativo" style="align-self: center; font-size: 2vw;">{{ getInterText(inter_ind.desativada) }}</span>
                                    </div>

                                </div>
                                <div v-if="currentTab == 2" style="display: flex; flex-direction: column; justify-content: center;">
                                    <img v-if="isFavorite(item.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 1vw" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />
                                    <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 1vw" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />
                                </div>



                            </div>
                        </div>



                        <!-- Comentarios -->
                        <div v-for="(item, index) in commentaries.slice().reverse()" v-if="(currentTab == 3)" class="di_mmp_estab0" style="width: 95vw; min-height: 15vw; padding: 3vw; padding-top: 4vw; padding-left: 4vw; padding-right: 1vw;" :key="item.id">
                            <div style="display: inline-block; text-align: start; width: 12%;">
                                <img v-if='hasHttp(item.userPhoto)'  :src='unscapePath(item.userPhoto)' alt="profile" class="im1" :title="item.userName">
                                <img v-else :src='baseUrlImg + "PROFILE/" + item.userPhoto'          alt="profile" class="im1" :title="item.userName">
                            </div>
                            <div style="display: flex; flex-direction: column; width: 76%; margin-left: 2%;" >

                                <div>
                                    <router-link :to="{ query: { id: item.idEstabelecimento }, params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'mEstabelecimento'}">
                                        <span style="font-weight: bold; display: inline-block;" v-html="decodeChars(item.estabName)"></span>
                                    </router-link>
                                </div>

                                <div @click="setShowRespComments(index)" style="cursor: pointer;">
                                    <div style="display: flex; flex-direction: row;">
                                        <span style="font-weight: bold"> {{ getFirstAndLastWords(item.userName) }}</span>
                                        <span style="margin-right: 1vw; margin-left: 1vw; color: #acadaf">{{ calcBehindTime(item.data) }}</span>
                                        <!--<img src="/static/imgs/bt_erase.png" alt="erase" class="im_del_comment" @click="rmCommentary(item.id)">-->
                                    </div>

                                    <div v-if="renderCommentaries" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                        {{ item.tx_trans }}
                                    </div>

                                    <div v-if="showRespComments != index" style="display: flex; flex-direction: column; position: relative; vertical-align: top; text-align: justify; margin-top: 1vw; margin-bottom: 1vw; color: #acadaf">
                                        <span class="tx_notselect" v-if="item.resps != undefined && item.resps.length == 1">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.resposta) }}</span>
                                        <span class="tx_notselect" v-if="item.resps != undefined && item.resps.length > 1">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.respostas) }}</span>
                                    </div>

                                    <div v-else style="display: flex; flex-direction: column; position: relative; vertical-align: top; text-align: justify; margin-top: 1vw; margin-bottom: 1vw; color: #acadaf">
                                        <span class="tx_notselect" v-if="item.resps != undefined && item.resps.length == 1" > {{ getInterText(inter_ind.resposta) }}: </span>
                                        <span class="tx_notselect" v-if="item.resps != undefined && item.resps.length > 1"> {{ getInterText(inter_ind.respostas) }}: </span>
                                    </div>
                                </div>

                                <div v-if="showRespComments==index" v-for="(itemResp, indexResp) in item.resps" style="display: flex; flex-direction: column; width: 100%; position: relative; margin-bottom: 2vw; " :key="itemResp.id">
                                    <div style="display: flex; align-items: flex-start; position: relative; height: 100%;">
                                        <div style="display: inline-block; text-align: start; width: 12%; height: 100%;">
                                            <img v-if='hasHttp(itemResp.userPhoto)'  :src='unscapePath(itemResp.userPhoto)' alt="profile" class="im1" style="object-fit: cover; width: 8vw; height: 8vw;" :title="itemResp.userName">
                                            <img v-else :src='baseUrlImg + "PROFILE/" + itemResp.userPhoto'              alt="profile" class="im1" style="object-fit: cover; width: 8vw; height: 8vw;" :title="itemResp.userName">
                                        </div>
                                        <div style="display: flex; flex-direction: column; width: 72%; align-self: flex-start; margin-left: 3%;">
                                            <div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">
                                                <span style="color: darkblue">{{ getFirstAndLastWords(itemResp.userName) }}</span>
                                                <span>{{ calcBehindTime(itemResp.data) }}</span>
                                                <!--<img src="/static/imgs/bt_erase.png" alt="erase" class="im_del_comment" @click="rmCommentary(itemResp.id)">-->
                                            </div>
                                            <div v-if="renderCommentaries" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                                {{ itemResp.tx_trans }}
                                            </div>

                                            <div style="color: #acadaf;">
                                                <span @click="setShowResponder(indexResp)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.responder) }}</span>
                                                <span v-if="itemResp.idUsuario == user.id" @click="rmCommentary(itemResp.id)" onMouseOver="this.style.cursor='pointer'" style="margin-left: 5vw;">{{ getInterText(inter_ind.excluir) }}</span>
                                            </div>

                                            <textarea v-if="showResponder==indexResp" type="text" class="search" style="width: 100%;" :placeholder="getInterText(inter_ind.responda_comentario)" v-model="commentRespTx"></textarea>
                                            <div v-if="showResponder==indexResp" style="display: flex; justify-content: flex-end;">
                                                <div style="background-color: var(--bg-purple); border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(item.id, index, item.idEstabelecimento)">
                                                    <span style="color: white; padding-right: 10px; padding-left: 10px;">{{ getInterText(inter_ind.enviar_resposta) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="div_joia2" style="width: 14%; align-self: flex-start; margin-top: 2vw;">
                                            <img v-if="isLiked(itemResp.id)" onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 0)" src="/static/imgs/ic_like_on.png" alt="joia up" class="im_joia1">
                                            <img v-else onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 1)"  src="/static/imgs/ic_like_off.png"  alt="joia up" class="im_joia1">
                                            <span style="margin-left: 5%;">{{ itemResp.qLikes }}</span>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div v-if="showRespComments == index && item.resps.length > 0" @click="setShowRespComments(index)" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center; width: 10%; margin-top: -1vw;">
                                <img src="/static/imgs/bt_fechar.png" alt="erase" class="im_del_comment">
                                <span style="color: #acadaf; font-size: 2vw;">{{ getInterText(inter_ind.fechar) }}</span>
                            </div>

                            <div v-else-if="item.idUsuario == user.id" style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 13%;">
                                <img src="/static/imgs/bt_erase.png" alt="erase" class="im_del_comment_big" @click="rmCommentary(item.id)">
                                <span style="color: #acadaf; font-size: 7pt;">{{ getInterText(inter_ind.excluir) }}</span>
                            </div>
                        </div>

                        <!-- Anuncios -->
                        <div v-for="item in getAnunciosDecoded(anuncios)" v-if="(currentTab == 5)" class="di_mmp_estab0">

                            <div class="di_mmp_estab1" style="display: flex; flex-direction: row; width: 75vw; height: 25vw;" >
                                <router-link :to="{ params: { product: truncateAnuncio(item), stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterAnuncio'}" style="margin: 0; padding: 0;">
                                    <div class="di_mmp_estab2" >
                                        <img onerror="tryReloadImages(this)" style="width: 33vw; height: 25vw; border-radius: 5px 0 0 5px; object-fit: cover;" v-if="item.photos !== undefined && item.photos[0]!=null" :src="baseUrlImg + '/MARCADOR/' + item.photos[0].file" alt="Foto Principal" class="imgDestaques"/><br>
                                    </div><br>
                                </router-link>
                                <div style="display: flex; flex-direction: column; width: 100%; margin-left: 2vw; justify-content: space-between; padding-bottom: 1vh; padding-top: 0.5vh;">
                                    <div style="display: flex; flex-direction: column;">
                                        <span class="tx_title_estab" v-html="decodeChars(item.titulo)"> </span>
                                        <span style="font-family: 'Humanst521LTBT'; font-size: 1.8vh;"> R$ {{ getCurrency(item.valor) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; width: 20vw; justify-content: center;">
                                <div style="display: flex; flex-direction: column; justify-content: space-evenly; align-items: center;">
                                    <router-link :to="{ params: { product: truncateAnuncio(item), stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterAnuncio'}">
                                        <div style="display: flex; flex-direction: row;" onMouseOver="this.style.cursor='pointer'">
                                            <img style="width: 4vw; height: 4vw; margin-right: 6px;" src='/static/imgs/ic_edit_sq.png' alt="Foto Principal" class="imgDestaques"/><br>
                                            <span style="align-self: center;">{{ getInterText(inter_ind.editar) }}</span>
                                        </div>
                                    </router-link>


                                    <div style="display: flex; flex-direction: row; align-items: center;" @click="sendAprovado(item)">
                                        <img v-if="item.ativo"  style="width: 2vw; height: 2vw; margin-right: 6px;" src='/static/imgs/ic_ball_green.png' alt="Foto Principal" class="imgDestaques"/>
                                        <img v-if="!item.ativo" style="width: 2vw; height: 2vw; margin-right: 6px;" src='/static/imgs/ic_ball_red.png' alt="Foto Principal" class="imgDestaques"/>
                                        <span v-if="item.ativo"  style="align-self: center; font-size: 2vw;">{{ getInterText(inter_ind.ativa) }}</span>
                                        <span v-if="!item.ativo" style="align-self: center; font-size: 2vw;">{{ getInterText(inter_ind.desativada) }}</span>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>



                <!-- ################    Botao Enviar    ################# -->
                <div style="display: flex; justify-content: center;" v-if="currentTab == 1">
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'mRegisterEstab'}">
                    <div style="margin-top: 5vh; padding: 1.3vh; margin-bottom: 10vh; background-color: var(--bg-blue); text-align: center; border-radius: 8px; width: 50vw;" onMouseOver="this.style.cursor='pointer'">
                        <span style="color: white; font-size: 2.2vh;">{{ getInterText(inter_ind.criar_pagina) }}</span>
                    </div>
                    </router-link>
                </div>

                <div style="display: flex; justify-content: center;" v-if="currentTab == 5">
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterAnuncio'}">
                        <div style="margin-top: 5vh; padding: 1.3vh; margin-bottom: 10vh; background-color: var(--bg-blue); text-align: center; border-radius: 8px; width: 50vw;" onMouseOver="this.style.cursor='pointer'">
                            <span style="color: white; font-size: 2.2vh;"> Criar Anúncio </span>
                        </div>
                    </router-link>
                </div>


            </div>
        </div>

        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_close_c.png" class="im_close_m" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center;">
                    <span class="tx_login3">{{ getInterText(inter_ind.entrar) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before" @click="clickInput3(editingLogin, 1, true)" v-if="!editingLogin[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr" @click="clickInput3(editingLogin, 1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editingLogin[1].status"/>
                    <span class="tx_nome" @click="clickInput3(editingLogin, 1, false)" v-if="editingLogin[1].status">E-mail</span>
                    <input id="emailid" class="input_name_m" type="text" v-model="editingLogin[1].texto" v-if="editingLogin[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editingLogin[1].texto) && editingLogin[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before" @click="clickInput3(editingLogin, 0, true)" v-if="!editingLogin[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr" @click="clickInput3(editingLogin, 0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editingLogin[0].status"/>
                    <span class="tx_nome" @click="clickInput3(editingLogin, 0, false)" v-if="editingLogin[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_m" type="password" v-model="editingLogin[0].texto" v-if="editingLogin[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editingLogin[0].texto) && editingLogin[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>

                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div class="div_botao_m" @click="tryLogin2(editingLogin[1].texto, editingLogin[0].texto)" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                    <span class="tx_continuar_w"> {{ getInterText(inter_ind.continuar) }} </span>
                </div>
            </div>
        </div>

        <horizontal-msg/>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_cinza" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_white" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 1 0"/>
        </filter>


        <div class="overlay"></div>

        <div class="overgalery" @click="showGalery(false)">
            <div class="div_galery" @click.stop.prevent="">
                <img onerror="tryReloadImages(this)" v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto Principal" class="imgGalery"/><br>
                <div class="div_arrow_l">
                    <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_left_2.png'" alt="Foto Anterior" @click="nextPhoto(-1)" class="im_arrow">
                </div>
                <div class="div_arrow_r">
                    <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_right_2.png'" alt="Foto Anterior" @click="nextPhoto(+1)" class="im_arrow">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'



    export default {
        mixins: [advMixin],
        name: 'mMinhaPagina',
        data () {
            return {
                name: 'mMinhaPagina',
                editingLogin: [
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                ],
                ticket: [
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                ],
                estabs: [],
                estab: [],
                estabs_full: [],
                cat: {},
                search_text: "",
                photoIndex: 0,
                showShare: false,
                showingSearch: false,
                actualWidth: 0,
                showCats: false,
                cepOk: true,
                showAddress: false,
                loading: {
                    cats: false,
                    estabs: false
                },
                response: {
                    status: "ok"
                },
                // tituloCat: "",
                // corCat: "",
                // corCat2: "#E4E4E4",
                msg_erros: [

                ],
                transpGif: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
                cats_full: [
                    {
                        "id": 67,
                        "apareceListagem": false,
                        "imgPath": "67.png",
                        "imgPath2": "67_2.png",
                        "nome": "Patrocinados",
                        "nomeEn": "Patrocinados",
                        "cor": "#FFFFFF",
                        "cor2": "#2566AE",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 1,
                    },
                    {
                        "id": 53,
                        "apareceListagem": false,
                        "imgPath": "53.png",
                        "imgPath2": "53_2.png",
                        "nome": "Destaques",
                        "nomeEn": "Destaques",
                        "cor": "#929497",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 2,
                    },
                    {
                        "id": 62,
                        "apareceListagem": false,
                        "imgPath": "62.png",
                        "imgPath2": "62_2.png",
                        "nome": "Turísticos",
                        "nomeEn": "Turísticos",
                        "cor": "#00A551",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 3,
                    },
                    {
                        "id": 63,
                        "apareceListagem": true,
                        "imgPath": "63.png",
                        "imgPath2": "63_2.png",
                        "nome": "Hospedagem",
                        "nomeEn": "Hospedagem",
                        "cor": "#FCB713",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 4,
                    },
                    {
                        "id": 55,
                        "apareceListagem": true,
                        "imgPath": "55.png",
                        "imgPath2": "55_2.png",
                        "nome": "Eventos",
                        "nomeEn": "Eventos",
                        "cor": "#56C4CF",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 4,
                    },
                    {
                        "id": 56,
                        "apareceListagem": true,
                        "imgPath": "56.png",
                        "imgPath2": "56_2.png",
                        "nome": "Restaurantes",
                        "nomeEn": "Restaurantes",
                        "cor": "#0071BB",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": true,
                        "ordem": 6,
                    },
                    {
                        "id": 58,
                        "apareceListagem": true,
                        "imgPath": "58.png",
                        "imgPath2": "58_2.png",
                        "nome": "Lanchonetes",
                        "nomeEn": "Lanchonetes",
                        "cor": "#006D38",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": true,
                        "ordem": 7,
                    },
                    {
                        "id": 57,
                        "apareceListagem": true,
                        "imgPath": "57.png",
                        "imgPath2": "57_2.png",
                        "nome": "Bares",
                        "nomeEn": "Bares",
                        "cor": "#47A4AD",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": true,
                        "ordem": 8,
                    },
                    {
                        "id": 59,
                        "apareceListagem": true,
                        "imgPath": "59.png",
                        "imgPath2": "59_2.png",
                        "nome": "Entretenimento",
                        "nomeEn": "Entretenimento",
                        "cor": "#F48120",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 9,
                    },
                    {
                        "id": 60,
                        "apareceListagem": false,
                        "imgPath": "60.png",
                        "imgPath2": "60_2.png",
                        "nome": "Cinema",
                        "nomeEn": "Cinema",
                        "cor": "#BDD630",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 9,
                    },
                    {
                        "id": 70,
                        "apareceListagem": true,
                        "imgPath": "70.png",
                        "imgPath2": "70_2.png",
                        "nome": "Cultura e Artes",
                        "nomeEn": "Cultura",
                        "cor": "#00ADEE",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 10,
                    },
                    {
                        "id": 61,
                        "apareceListagem": true,
                        "imgPath": "61.png",
                        "imgPath2": "61_2.png",
                        "nome": "Kids",
                        "nomeEn": "Kids",
                        "cor": "#FFF100",
                        "cor2": "#F48120",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 11,
                    },
                    {
                        "id": 64,
                        "apareceListagem": true,
                        "imgPath": "64.png",
                        "imgPath2": "64_2.png",
                        "nome": "Fitness",
                        "nomeEn": "Fitness",
                        "cor": "#AF1116",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 12,
                    },
                    {
                        "id": 72,
                        "apareceListagem": true,
                        "imgPath": "72.png",
                        "imgPath2": "72_2.png",
                        "nome": "Aventura",
                        "nomeEn": "Adventure",
                        "cor": "#A2238D",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 13,
                    },
                    {
                        "id": 71,
                        "apareceListagem": false,
                        "imgPath": "71.png",
                        "imgPath2": "71_2.png",
                        "nome": "Conveniência",
                        "nomeEn": "Conveniência",
                        "cor": "#D1AA67",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 15,
                    },
                    {
                        "id": 68,
                        "apareceListagem": false,
                        "imgPath": "68.png",
                        "imgPath2": "68_2.png",
                        "nome": "Serviços",
                        "nomeEn": "Serviços",
                        "cor": "#EB008B",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 16,
                    },
                    {
                        "id": 66,
                        "apareceListagem": false,
                        "imgPath": "66.png",
                        "imgPath2": "66_2.png",
                        "nome": "Emergência",
                        "nomeEn": "Emergência",
                        "cor": "#EC1C24",
                        "cor2": "",
                        "deleted": false,
                        "alimentacao": false,
                        "ordem": 17,
                    }
                ],

            }
        },
        methods: {
            removePhoto(index) {
                this.photos.splice(index, 1);
            },
            goToBack() {
                window.location.href = 'https://www.adviceparaiba.com/mHome';
            },
            setPointerCursor(event) {
                event.target.style.cursor = 'pointer';
            },
            showCategorias() {
                this.showCats = !this.showCats;
            },
            selectCat(index) {
                console.log('selecCat index ' + index);
                this.cats_full[index].deleted = !this.cats_full[index].deleted;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            handleResize (event) {
                this.actualWidth = window.innerWidth;
                // console.log('window.innerWidth: ' + actualWidth);
            },
            trimAll(str){
                return str.replace(/\s/g,'');
            }
        },
        created() {
            console.log('mMinhaPagina::created!!');

            if (this.user.currentTab == undefined || this.user.currentTab == 0) {
                this.user.currentTab = 3;
            }
            this.currentTab = this.user.currentTab;

            this.getCommentaries(this.user.id, 0);

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                }
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCats();
                console.log('Baixando comentarios, user: ', this.user);
            }

            if (this.$route.params.anuncios) {
                console.log('Usando anuncios passados por parametro!!');
                this.anuncios = this.$route.params.anuncios;
            }
            else {
                console.log('Baixando estabs!!');
                this.getAnuncios();
            }

            console.log('trajes: ');
            console.log(this.traje);

            console.log('mMinhaPagina::Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted::mMinhaPagina!!');

            $(document).ready(function () {
                $('#dismiss, .overlay').on('click', function () {
                    $('#sidebar').removeClass('active');
                    $('.overlay').fadeOut();
                });

                $('#sidebarCollapse').on('click', function () {
                    $('#sidebar').addClass('active');
                    $('.overlay').fadeIn();
                    $('.collapse.in').toggleClass('in');
                    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
                });
            });

            this.barra_pat = this.shuffle(this.barra_pat);

            if (this.user.idioma > 0) {
                this.changeIdioma(this.user.idioma);
            }

            console.log('mMinhaPagina::Terminei o mounted!!');
        },
    }
</script>


<style src="../assets/css/adv.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        background-color: var(--main-bg-color);
        /*background-color: #E4E4E4;*/
    }
    .title0 {
        /*background-color: red;*/
        text-align: left;
    }
    .head0 {
        position: fixed;
        top: 0;
        z-index: 1;
    }
    .im_menu1 {
        height: 25px;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        margin-top: auto;
        margin-bottom: auto;
        position: relative;
        margin-left: 0px;
    }
    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }

    .di_mmp_estab0 {
        background-color: white;
        display: flex;
        flex-direction: row;
        /*background-color: green;*/
        border-radius: 5px;
        margin-bottom: 2vw;
        -webkit-box-shadow: 0 0 3px #AAAAAADD;
        -moz-box-shadow: 0 0 3px  #AAAAAADD;
        box-shadow: 0 0 3px #AAAAAADD;
        /*box-shadow: 2px 2px 2px var(--font-shadow-gray);*/
    }

    .im_profile, .im_traje, .im_photos, .im_photos_back {
        display: flex;
        height: 60%;
    }
    .im_profile {
        margin-top: 12px;
    }
    .im_degrade {
        position: absolute;
        width: 100%;
        height: 12px;
    }
    .im_cat_min, .im_cat_min2, .im_cat_min2_gray {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        object-fit: contain;
    }
    .title {
        display: flex;
        align-items: center;
        justify-content: left;
        background-color: white;
        border-radius:5px;
        margin-right: 2vw;
        margin-left: 2vw;
        margin-bottom: 1vw;
        padding: 2px;
        font-size: 20pt;
    }
    .div_arrow_l, .div_arrow_r {
        position: absolute;
        top:0;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
    }
    .div_arrow_r {
        right: 2px;
    }
    .div_arrow_l {
        left: 2px;
    }
    .im_arrow {
        position: absolute;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
    }
    .im_arrow:hover {
        -webkit-filter: brightness(70%);
        filter: brightness(70%);
    }

    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.85);
        z-index: 1;
        display: none;
        vertical-align: middle;
        top: 0;
    }
    .div_galery {
        vertical-align: middle;
        display: inline-block;
        z-index: 1;
        position: relative;
        top: 50%;
        left: 50%;
        padding-right: 10px;
        padding-left: 10px;
        transform: translate(-50%, -50%);
    }
    .imgGalery {
        width: 95vw;
        object-fit: fill;
    }
    .im_pat {
        height: 1cm;
        margin-left: 0.3cm;
        margin-right: 0.3cm;
        margin-bottom: 0.4cm;
        margin-top: 0.4cm;
    }
    .div_pat {
        position: page;
        bottom: 0;
        display: inline-block;
        /*background-color: #949494;*/
        /*background-color: #B4B4B4;*/
        /*background-color: #C4C4C4;*/
        background-color: #CDCDCD;
        /*background-color: #A6A8AB;*/
        /*background-color: #E4E4E4;*/
        padding-top: 0.25cm;
        padding-bottom: 0.5cm;
        text-align: center;
    }
    .tx_parceiros {;
        font-size: 11pt;
        /*color: #040505;*/
        color: #858585;
    }


    .di_photo, .di_photo_traje, .di_photo_ticket {
        display: inline-block;
        /*background-color: red;*/
        position: relative;
        height: 100%;
        margin: 5px;
    }
    .di_photo {
        /*background-color: var(--bg-blue);*/
        background-size: contain;
        border-radius: 50%;
        padding: 4px;
        position: relative;
    }
    .di_photo_traje {
        margin-right: 3vw;
        /*background: blue;*/
    }
    .di_photo_ticket {
        padding: .3vw;
        margin: .6vw;
    }
    .di_form_item, .di_form_item_s, .di_form_item2, .di_form_item2_b {
        display: flex;
        flex-direction: column;
        background: white;
        border-radius:10px;
        margin-right: 0.5%;
        margin-left: 0.5%;
        margin-bottom: 2%;

        padding-right: 2%;
        padding-left: 5%;
        padding-bottom: 2%;
        padding-top: 2%;
    }

    .di_form_item_s {
        background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2));
        margin-bottom: 1%;
    }

    .di_form_item2, .di_form_item2_b {
        align-items: center;
        flex-direction: row;
        background-color: white;
        width: 100%;
    }
    .di_form_item2_b {
        background-color: var(--bg-blue);
    }

    .di_form_item_c {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
    }
    .di_form_item_c2 {
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        flex-basis: 40%;
    }

    .im_traje2, .im_traje2_s {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    .im_traje2_s {
        filter: url(#colorize_white);
    }

    .dv_traje2, .dv_traje2_s {
        width: 60px;
        height: 60px;
        background-color: white;
        padding-bottom: 9px;
        padding-top: 9px;
        border-radius: 50%;
        box-shadow: 0px 0px 10px #c0c0c0;
    }

    .dv_traje2_s {
        background-color: var(--bg-blue);
    }

    .di_circle, .di_circle_s {
        width: 4vw;
        height: 4vw;
        background: white;
        border-radius: 50%;
        box-shadow: -1px 1px 2px var(--font-dark-gray);
    }
    .di_circle_s {
        background-color: var(--bg-blue);
    }

    .im_photos, .im_photos0, .im_photos_back, .im_photos_back_s {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        object-fit: cover;
    }

    .im_photos, .im_photos_back, .im_photos_back_s {
        width: 86px;
        height: 86px;
        background-color: white;
        position: relative;

    }

    .im_photos {

        margin: 6px;
        margin-left: -80px;
        width: 74px;
        height: 74px;
    }

    .im_photos_back {
        -webkit-animation: rotation 3s infinite linear;
    }

    .im_photos_back_s {
        background-color: var(--bg-blue);
    }


    @-webkit-keyframes rotation {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
        }
    }

    .di_photo0 {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 5px;
        min-width: 90px;
        width: 90px;
        height: 90px;
        background: #EEE;
        margin-left: 10px;
        border-radius: 50%;
        padding: 10px;
        padding-top: 20px;
    }

    .im_photos0 {
        /*background: green;*/
        object-fit: contain;
        border-radius: 0;
        padding: 0px;
        width: 70%;
        height: 61%;
    }
</style>



// WEBPACK FOOTER //
// src/components/mMinhaPagina.vue